import {
  Component,
  ChangeDetectionStrategy,
  viewChild,
  AfterViewInit,
  ViewContainerRef,
  ElementRef,
  input,
  output,
  signal,
  inject,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ModalFactory } from '@shared/abstraction/modal/modal-factory';
import { DialogFactoryService } from '@shared/services/dialog-factory.service';
import { fromEvent, timer } from 'rxjs';

@Component({
  standalone: false,
  selector: 'gstar-global-dialog',
  templateUrl: './global-dialog.component.html',
  styleUrl: './global-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalDialogComponent implements AfterViewInit, ModalFactory {
  private readonly translate = inject(TranslateService);
  private readonly dialogFactory = inject(DialogFactoryService);

  title = input.required<string>();
  cancelLabel = input<string>(this.translate.instant('shared.cancel'));
  confirmLabel = input<string>(this.translate.instant('shared.confirm'));
  hideCancel = input<boolean>(false);
  hideConfirm = input<boolean>(false);
  disableConfirm = input<boolean>(false);

  // eslint-disable-next-line @angular-eslint/no-output-native
  cancel = output<boolean | undefined>();
  confirm = output<boolean>();

  backDrop = viewChild<ElementRef<HTMLDivElement>>('backdrop');
  modal = viewChild<ElementRef<HTMLDivElement>>('modal');
  dynamicContentHost = viewChild('dynamicContentHost', {
    read: ViewContainerRef,
  });

  isOpen = signal(false);

  constructor() {
    timer(0).subscribe(() => {
      this.isOpen.set(true);
    });
  }

  ngAfterViewInit(): void {
    if (this.backDrop() && this.backDrop()!.nativeElement) {
      fromEvent(this.backDrop()!.nativeElement, 'click').subscribe(
        (event: Event) => {
          if (
            event.target &&
            !this.modal()?.nativeElement.contains(event.target as Node)
          ) {
            this.cancelHandler(undefined);
          }
        }
      );
    }
  }

  cancelHandler(result?: boolean): void {
    this.isOpen.set(false);
    this.cancel.emit(result);
  }

  confirmHandler(): void {
    this.isOpen.set(false);
    this.confirm.emit(true);
  }
}
